/* eslint-disable import/prefer-default-export */
import { US_COUNTRY_CODE } from '@cont/Login/constants';

export const isLocationUS = (geolocationData) =>
  geolocationData?.countryCode === US_COUNTRY_CODE;
